//
//  EditDependant Reducer
//  CXA Apollo
//
//  Created on 09/01/2017.
//  Copyright (c) 2017 CXA. All rights reserved.
//

// Add ALL your actions into import list
import {
  LOAD_DEPENDANT_FIELDS_SUCCESS,
  SET_DEPENDANT_ID,
  LOAD_DEPENDANT_SUCCESS,
  SET_EDIT_DEPENDANT_FORM_LOADED,
  SAVE_DEPENDANT_SUCCESS,
  SAVE_DEPENDANT_FAIL,
  RESET_DEPENDANT_FORM,
} from "../actions/dependantActions";

import _ from "lodash";

const initialState = {
  formValues: {},
  fields: [],
  employeeKey: 0,
  dependantId: 0,
  dependant: {},
  formDataLoaded: false,
  formSubmitSucceeded: false,
  formSubmitFailed: false,
  error: null,
};

const transformDependantData = data =>
  data.reduce((d, field) => ({ ...d, [field.id]: field.value }), {});

const getDependantsData = responseData => {
  const { dependantListDTO } = responseData;

  if (!dependantListDTO) {
    return {};
  }

  const { dependants, fields } = dependantListDTO;

  return dependants.reduce(
    (obj, item) => ({
      ...obj,
      [item.dependantKey]: fields.reduce(
        (obj, prop) => ({
          ...obj,
          [prop.id]: transformDependantData(item.data)[prop.id],
        }),
        {}
      ),
    }),
    {}
  );
};

export const getFields = state => _.get(state, "fields");

export const getDependant = (state, id) => (state && id ? state.byId[id] : {});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LOAD_DEPENDANT_FIELDS_SUCCESS:
      return {
        ...state,
        fields: getFields(action.payload),
      };

    case LOAD_DEPENDANT_SUCCESS: {
      const dependantsById = getDependantsData(action.payload);
      const dependantId = action.meta.dependantId;
      let dependant;
      if (!dependantId) {
        dependant = {};
      } else {
        dependant = dependantsById ? dependantsById[dependantId] : {};
      }
      return { ...state, dependant };
    }
    case SET_DEPENDANT_ID:
      return {
        ...state,
        dependantId: action.payload.dependantId,
        employeeKey: action.payload.employeeKey,
      };
    case SET_EDIT_DEPENDANT_FORM_LOADED:
      return {
        ...state,
        formDataLoaded: true,
      };

    case SAVE_DEPENDANT_SUCCESS:
      return { ...state, formSubmitSucceeded: true };
    case SAVE_DEPENDANT_FAIL:
      return { ...state, formSubmitFailed: true, error: action.payload };
    case RESET_DEPENDANT_FORM:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/dependantsReducer.js